<template>
    <div class="moon-header">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name:'MoonHeader'
    };
</script>

<style lang="scss" scoped>

</style>